import React, { Component } from "react";
import { connect } from "react-redux";
import { getMessagerieFicheSimple } from "../les-tabs-ducks/MessagerieFiche.ducks";
import _ from "lodash";
import moment from "moment";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import InfiniteScroll from "react-infinite-scroll-component";
import { API } from "../../../../../const";
import { Service } from "../../../../../modules/service/service";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const divStyleScroll = {
  overflow: "none",
};
class MessagerieFiche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      offset: 1,
      msgsLoading: true,
      scrollLoader: false,
      page: 1,
      hasMoreItems: true,
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${id}/messages?offset=1&path-size=40`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      let sortedKids = res.data.messages.elements.sort((a, b) =>
        moment(b.dateTime).diff(a.dateTime)
      );
      this.setState({
        history: sortedKids,
        msgsLoading: false,
        page: res.data.messages.pagesNumber,
        totalElements: res.data.messages.totalElements,
      });
    });
  }
  loadMore() {
    this.setState({
      scrollLoader: true,
    });
    if (this.state.history.length === this.state.totalElements) {
      this.setState({ hasMoreItems: false });
    } else {
      setTimeout(() => {
        let tok = localStorage.getItem("token");
        let offset = this.state.offset + 1;
        let id = window.location.pathname.match(/\d+/g)[0];

        const response = Service.get(
          `${API}api/enfant/creche/enfants/${id}/messages?offset=${offset}&path-size=40`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          let sortedKids = this.state.history.concat(
            res.data.messages.elements
          );
          sortedKids = sortedKids.sort((a, b) =>
            moment(b.dateTime).diff(a.dateTime)
          );
          this.setState({
            history: sortedKids,
            offset: offset,
            scrollLoader: false,
          });
        });
      }, 500);
    }
  }

  render() {
    return (
      <div
        className="tab-pane show active "
        id="messagerie-fiche-pane"
        role="tabpanel"
        aria-labelledby="messagerie-fiche-tab"
      >
        <div className="content p-0">
          <section className="content-section border-0 mb-0">
            <h2>Messagerie Parents</h2>

            <div class="fake-table-style">
              <div class="thead row">
                <div class="col-3" style={{ width: "20%" }}>
                  Date
                </div>
                <div class="col-9">Sujet</div>
              </div>
              <InfiniteScroll
                style={divStyleScroll}
                dataLength={this.state.history.length}
                next={this.loadMore}
                hasMore={this.state.hasMoreItems}
                loader={
                  <div className="content p-0">
                    <DotLoader
                      size={100}
                      color={"#ff7d26"}
                      css={override}
                      loading={this.state.msgsLoading}
                    />
                  </div>
                }
              >
                <OnePageHisto history={this.state.history} />
              </InfiniteScroll>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.ficheEnfant.MessagerieFiche.loading,
});

export default connect(mapStateToProps, { getMessagerieFicheSimple })(
  MessagerieFiche
);

function OnePageHisto({ history }) {
  return (
    <div class="tbody">
      {history.map((histo, index) => (
        <div class="tr row" key={index}>
          {_.isEmpty(histo.dateTime) ? (
            <div class="col-3"> {moment().format("DD/MM/YYYY")}</div>
          ) : (
            <div class="col-3">
              {" "}
              {moment(histo.dateTime).format("DD/MM/YYYY")}
            </div>
          )}
          <div class="col-9">{histo.body}</div>
        </div>
      ))}
    </div>
  );
}
